module.exports = __webpack_public_path__ + "img/painting.4f39deb6.jpg";